import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageMenu from '../../../blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import useDecode from "hooks/useDecode";
import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';
import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import SolicitudVolanteAsistencia from "./SolicitudVolanteAsistencia";

const GridSolicitudVolanteAsistencia = () => {
    const title = 'Solicitud Volante de Asistencia' // CAMBIAR TITULO
    const navigate = useNavigate();

    /// OBTENER TOKEN PARA LAS PETICIONES ///
    const tokenResponse = useDecode("token");
    const userId = tokenResponse && tokenResponse.extension_id;

    const [arrData, setArrData] = useState(null)
    const [dataUser, setDataUser] = useState(null);
    const [info, setInfo] = useState(false);
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [generateKey, setGenerateKey] = useState(0);

    const rowSelected = (args) => { // SELECCIONAR UN FORMULARIO E IMPRIMIRLO
        setInfo(false)
        setLoading(true)
        setShow(false)
        setTimeout(() => { //Darle tiempo actualizar el DOM
            setShow(true)
            setLoading(false)
        }, 200);

        const selectedData = args.data;
        setDataUser(selectedData);

    };

    const handleInfo = () => {
        setGenerateKey(prev => prev + 1); //OBTENER INFORMACION EN EL BOTON
        setLoading(true)
        setInfo(true)
        setShow(false)


        setDataUser({ Observaciones: "Hola", FechaAceptacionSolicitud: "", RazonSocial: "COLORES AZULADOS S.L" }) //Agregar el Get Necesario


        if (dataUser) {
            setTimeout(() => { //Darle tiempo actualizar el DOM
                setShow(true)
                setLoading(false)
            }, 200);
        }
    }

    useEffect(() => { // CUANDO CAMBIA DATAUSER SE RECARGA EL FORMULARIO
        setLoading(true)
        setShow(false)
        setTimeout(() => {//Darle tiempo actualizar el DOM
            setShow(true)
            setLoading(false)
        }, 200);
    }, [dataUser]);
    useEffect(() => {
        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 0);
            setShowGenerateButton(!hasFormZero);
        }
    }, [arrData]);

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title} >
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>
            <ManagementFormCardList dataSource={arrData || []} onSelect={rowSelected} key={generateKey} />
            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={() => handleInfo()}>
                        Generar Formulario
                    </button>
                    </div>
                </div>
            )}
            <Loader activeLoader={loading} label="Cargando Formulario"></Loader>
            {dataUser && (dataUser?.BoolResultado !== false) && show && (
                <div className="mt-5">
                    <SolicitudVolanteAsistencia
                        dataUser={dataUser}
                        info={info} />
                </div>
            )}
            {dataUser && show && dataUser?.BoolResultado === false &&
                <ErrorDisplay descripcionError={dataUser.Descripcion} />
            }

        </div>
    );
};
export default GridSolicitudVolanteAsistencia;
